import { Terminal } from '@/models/terminal';
import { Avatar, Card, Col, Empty, List, Row, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import TransactionLog from '../../audit-logs/components/transaction-log/transaction-log';
import './index.scss';


interface TerminalDetailProps {
  terminal?: Terminal;
}

function AppList(props: TerminalDetailProps) {
  const { t } = useTranslation();
  
  const data = [
    {
      title: 'Tax Free(1.022)',
    },
    {
      title: 'WORLDLINE',
    },
    {
      title: 'PAX',
    },
    {
      title: 'FISERV AU',
    },    
    {
      title: 'Mobile Telnet(4.20)',
    },
  ];

  return (
    <Row gutter={24}>
      <Col span={24}>
        <Card
          style={{ marginTop: 16 }}
          title="Installed Apps"
        >
          <Row>
         <Col span={24}>
            <List
          itemLayout="horizontal"
          dataSource={data}
          renderItem={(item, index) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={`https://api.dicebear.com/8.x/icons/svg?seed=${index}`} />}
                title={<a>{item.title}</a>}
                description={`${item.title}, a application, is refined by Ugotechs Teams`}
              />
            </List.Item>
          )}
        />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
export default AppList;
